/* ─── Root ─── */

.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.label {
  composes: label from "../TextInput/TextInput.module.css";
}

.description {
  composes: description from "../TextInput/TextInput.module.css";
}

.error {
  composes: error from "../TextInput/TextInput.module.css";
}

.root[data-invalid] .inputWrapper {
  box-shadow: inset 0 0 0 2px var(--md-error);
}

.root[data-disabled] {
  opacity: 0.38;
  cursor: not-allowed;
}

/* ─── Input wrapper (pill) ─── */

.inputWrapper {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  height: 3rem;
  padding-inline: var(--space-3);
  border-radius: var(--shape-full);
  background: var(--md-surface-container-highest);
  border: 1px solid var(--md-outline-variant);
  transition: box-shadow var(--motion-duration-short3)
    var(--motion-easing-standard);
}

.inputWrapper:focus-within {
  box-shadow: var(--elevation-2);
}

/* ─── Search icon ─── */

.searchIcon {
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
  color: var(--md-on-surface-variant);
}

/* ─── Input ─── */

.input {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  all: unset;
  flex: 1;
  min-width: 0;
  font-family: var(--font-sans);
  color: var(--md-on-surface);
}

.input::placeholder {
  color: var(--md-on-surface-variant);
}

/* Hide native search cancel button */
.input::-webkit-search-cancel-button {
  -webkit-appearance: none;
  appearance: none;
  display: none;
}

.root[data-disabled] .input {
  cursor: not-allowed;
}

/* ─── Clear button ─── */

.clearBtn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  padding: 0;
  border: none;
  border-radius: var(--shape-full);
  background: transparent;
  color: var(--md-on-surface-variant);
  cursor: pointer;
  flex-shrink: 0;
}

.clearBtn::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .clearBtn:hover::before {
    opacity: var(--state-hover);
  }
}

.clearBtn:focus-visible::before {
  opacity: var(--state-focus);
}

.clearBtn:active::before {
  opacity: var(--state-pressed);
}

.clearBtn svg {
  width: 0.875rem;
  height: 0.875rem;
}
